import Vue from 'vue';
import $Cookies from 'js-cookie'
import { Ajax as $Ajax, httpRequest as $HttpRequest,MD5 as $MD5, baseURL as $BaseURL} from '@/ajax'
import { dateFormat as $DateFormat, queryString as $QueryString } from 'riku-verycloud'

const plugins = {
    install(Vue, options = {}) {
      Object.assign(Vue.prototype, {
        $Ajax,
        $HttpRequest,
        $MD5,
        $BaseURL,
        $DateFormat,
        $QueryString,
        $Cookies,
      })
    }
}

import {
    PullRefresh,
    Toast,
    Panel,
    Overlay,
    Button,
    Icon,
    Pagination,
    CountDown,
    Grid,
    GridItem,
    Form,
    Dialog,
    Field,
    NavBar,
    Search,
    Tabs,
    Tab,
    DropdownMenu,
    DropdownItem,
    List,
    Cell,
    Image,
    RadioGroup, 
    Radio,
    Checkbox, 
    CheckboxGroup,
    CellGroup,
    Image as VanImage,
    Lazyload,
    Loading,
    Swipe,
    SwipeItem,
    ImagePreview,
    GoodsAction, 
    GoodsActionIcon, 
    GoodsActionButton,
    Sku,
    Divider,
    ActionSheet,
    AddressEdit,
    Area,
    Popup,
    Picker,
    Switch,
    NoticeBar,
    Uploader,
    Popover,
    Rate,
    Tabbar, 
    TabbarItem,
    Sidebar,
    SidebarItem,
    Stepper,
    Sticky ,
    DatetimePicker,
    Collapse,
    CollapseItem,
    PasswordInput,
    NumberKeyboard,
    Badge,
    Skeleton,
    ContactList,
    SwipeCell,
    Progress
} from 'vant'

Vue.use(PullRefresh)
Vue.use(Toast)
Vue.use(Panel)
Vue.use(Overlay)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Pagination)
Vue.use(CountDown)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(NavBar)
Vue.use(Search)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(List)
Vue.use(Cell)
Vue.use(Image)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(CellGroup)
Vue.use(VanImage)
Vue.use(Lazyload)
Vue.use(Loading)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(ImagePreview)
Vue.use(GoodsAction)
Vue.use(GoodsActionIcon)
Vue.use(GoodsActionButton)
Vue.use(Sku)
Vue.use(Divider)
Vue.use(ActionSheet)
Vue.use(AddressEdit)
Vue.use(Area)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Switch)
Vue.use(NoticeBar)
Vue.use(Uploader)
Vue.use(Popover)
Vue.use(Rate)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Stepper)
Vue.use(Sticky)
Vue.use(DatetimePicker)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(Badge)
Vue.use(Skeleton)
Vue.use(ContactList)
Vue.use(SwipeCell)
Vue.use(Progress)

import lottie from "vue-lottie";
Vue.component("lottie", lottie);

export default plugins